import React from "react";
import Modal from "./Modal";
import { TOUR_REEL_ID } from "../../config";
import "./virtualTourModal.css";

const REEL_URL = `https://www.instagram.com/reel/${TOUR_REEL_ID}/`;

export default function VirtualTourModal({ onClose }) {
  return (
    <Modal onClose={onClose} label="Virtual tour of Learning In Motion Academy">
      <div className="tour-video">
        <iframe
          className="tour-frame"
          src={`${REEL_URL}embed`}
          title="Learning In Motion Academy virtual tour"
          allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
          allowFullScreen
        />
        <a className="tour-fallback" href={REEL_URL} target="_blank" rel="noreferrer">
          Watch on Instagram
        </a>
      </div>
    </Modal>
  );
}
